import * as React from 'react'
import { styled } from '../theme'

export class Fieldset extends React.Component<{ name?: React.ReactNode }, {}> {
  public render() {
    const { children, name } = this.props
    return (
      <FieldsetStyled>
        {name && <TitleStyled>{name}</TitleStyled>}
        {children}
      </FieldsetStyled>
    )
  }
}

const FieldsetStyled = styled.fieldset`
  border-bottom: 1px solid #e9e9e9;
  padding: 20px 0;
  margin: 0 0 20px 0;
`
const TitleStyled = styled.h3`
  font-weight: bold;
  margin: 0;
  padding: 0 0 20px 0;
`
